import base from './base';
import cleanCanvas from './clean-canvas';
import overlayMobile from './overlay-mobile';
import lean from './lean';
import mobileSticky from './mobile-sticky';

const types = {
    base, // standard looking popup
    'clean-canvas': cleanCanvas, // no markup at all. just a floating container. use for custom configuration popups
    lean, // clean popup, not much styling. use for long content. white background.
    'overlay-mobile': overlayMobile, // full screen popup for mobile pages
    'mobile-sticky': mobileSticky // sticky top/bottom mobile popup
};

export default types;


// WEBPACK FOOTER //
// ./src/fPopup/popup_types/index.js